export default __webpack_public_path__ + "static/media/area.d6db5666.svg";